
import type { ReagentFormData, ReagentFormErrors } from '@/types/reagent.types';

export const validateReagentForm = (formData: ReagentFormData): { isValid: boolean; errors: ReagentFormErrors } => {
  console.log("Validating form data:", formData);
  const errors: ReagentFormErrors = {};

  if (!formData.name || !formData.name.trim()) {
    errors.name = "Reagent name is required";
  }

  if (!formData.catalogNumber || !formData.catalogNumber.trim()) {
    errors.catalogNumber = "Catalog number is required";
  }

  if (!formData.category) {
    errors.category = "Category is required";
  }

  const isValid = Object.keys(errors).length === 0;
  console.log("Form validation result:", { isValid, errors });

  return { isValid, errors };
};

// Re-export the types from the central types file
export type { ReagentFormData, ReagentFormErrors } from '@/types/reagent.types';
